export default class CommandSvc {
  axios = null;
  busy = false;

  constructor(axios) {
    this.axios = axios;
  }

  isBusy() {
    return this.busy;
  }

  get(svc, url, successFunction, errorFunction) {
    var _this = this;
    var _svc = svc;

    _this.busy = true;
    _svc.$forceUpdate();

    this.axios.get(url)
    .then(function (response) {
       _this.busy = false;
       _svc.$forceUpdate();
       successFunction(response.data)
    })
    .catch(function (error) {
       console.log('Command GET URL: ' + url + ' ERROR: ' + error);
       _this.busy = false;
       _svc.$forceUpdate();
       if (errorFunction !== undefined && errorFunction !== null) {
         errorFunction(error);
       }
    });
  }

  post(svc, url, successFunction, errorFunction) {
    var _this = this;
    var _svc = svc;

    _this.busy = true;
    _svc.$forceUpdate();

    this.axios.post(url)
    .then(function (response) {
       _this.busy = false;
       _svc.$forceUpdate();
       successFunction(response.data)
    })
    .catch(function (error) {
       console.log('Authenticate ERROR: ' + error);
       _this.busy = false;
       _svc.$forceUpdate();
       if (errorFunction !== undefined && errorFunction !== null) {
         errorFunction(error);
       }
    });
  }

  put(svc, url, successFunction, errorFunction) {
    var _this = this;
    var _svc = svc;

    _this.busy = true;
    _svc.$forceUpdate();

    this.axios.put(url)
    .then(function (response) {
       _this.busy = false;
       _svc.$forceUpdate();
       successFunction(response.data)
    })
    .catch(function (error) {
       console.log('Authenticate ERROR: ' + error);
       _this.busy = false;
       _svc.$forceUpdate();
       if (errorFunction !== undefined && errorFunction !== null) {
         errorFunction(error);
       }
    });
  }

  delete(svc, url, successFunction, errorFunction) {
    var _this = this;
    var _svc = svc;

    _this.busy = true;
    _svc.$forceUpdate();

    this.axios.delete(url)
    .then(function (response) {
       _this.busy = false;
       _svc.$forceUpdate();
       successFunction(response.data)
    })
    .catch(function (error) {
       console.log('Authenticate ERROR: ' + error);
       _this.busy = false;
       _svc.$forceUpdate();
       if (errorFunction !== undefined && errorFunction !== null) {
         errorFunction(error);
       }
    });
  }
}